wbApp.factory('rentSvc', ['$resource', '$q', 'repositorySvc', 
    function ($resource, $q, repositorySvc) {

        var Rent = $resource('/restapi/rents/:id', {}, {
            'getById': { method: 'GET', url: '/restapi/rents/:id' },
            'getAll': { method: 'GET', isArray: true, url: '/restapi/rents' },
            'getAllByPlaceAndDateRange': { method: 'GET', isArray: true, url: '/restapi/rents/info/range/find-by-place' },
            'getAllByPlaceAndItemAndDateRange': { method: 'GET', isArray: true, url: '/restapi/rents/info/range/find-by-place-and-item' },
            'getAllByPlaceAndRentCategoryAndTypeAndUserDateRange': { method: 'GET', isArray: true, url: '/restapi/rents/info/range/find-by-place-and-rent-category-and-item-type-and-user' },
            'getAllByPlaceAndRentCategoryAndTypeAndDateRange': { method: 'GET', isArray: true, url: '/restapi/rents/info/range/find-by-place-and-rent-category-and-item-type' },
            'insert': { method: 'POST', url: '/restapi/rents' },
            'update': { method: 'PUT', url: '/restapi/rents/:id' },
            'delete': { method: 'DELETE', url: '/restapi/rents/:id' },
        });

        function createNew(placeId)
        {
            // TODO: set up time based on rent category
            // TODO: rounding to closes X minutes
            const now = moment();
            const remainder = 30 - (now.minute() % 30);
            const start = now.add(remainder, "minutes");

            // TODO: default rent length
            const end = moment(start).add(1, "hour");

            var rent = {
                isNew: true,
                placeId: placeId,
                fromUtc: start.toDate(),
                toUtc: end.toDate(),
                rentedItems: [],
                status: {
                    id: null,
                    createdAtUtc: null,
                    status: 0,
                    notes: null
                }
            };

            return rent;
        }

        function modelToDTO(model) {
            var dto = angular.copy(model);
            dto.fromUtc = moment(dto.fromUtc).utc().format();
            dto.toUtc = moment(dto.toUtc).utc().format();

            return dto;
        }

        function insert(model) {
            return repositorySvc.customPost(
                'insert',
                Rent,
                modelToDTO(model));
        }

        function remove(rentId) {
            return repositorySvc.customDelete(
                'delete',
                Rent,
                { id: rentId });
        }

        function update(model) {
            return repositorySvc.customPutWithParams(
                'update',
                Rent,
                { id: model.id },
                convertDatesToDateString(model));
        }

        function getById(rentId) {
            return repositorySvc.customGet('getById', Rent, { id: rentId });
        }

        function getAll(refresh) {
            return repositorySvc.customGet('getAll', Rent, {});
        }

        function getAllByPlaceAndDateRange(placeId, fromDateUtc, toDateUtc) {
            return repositorySvc.customGet('getAllByPlaceAndDateRange', Rent, {
                fromDateUtc: moment(fromDateUtc).startOf('day').utc().format(),
                toDateUtc: moment(toDateUtc).endOf('day').utc().format(),
                placeId: placeId,
                expanded: 'PersonalInformation,RentItemDetails,RentCategoryDetails,ItemTypeDetails'
            });
        }

        function getAllByPlaceAndItemAndDateRange(placeId, itemId, fromDateUtc, toDateUtc) {
            return repositorySvc.customGet('getAllByPlaceAndItemAndDateRange', Rent, {
                fromDateUtc: moment(fromDateUtc).startOf('day').utc().format(),
                toDateUtc: moment(toDateUtc).endOf('day').utc().format(),
                placeId: placeId,
                itemId: itemId,
                expanded: 'PersonalInformation,RentItemDetails,RentCategoryDetails,ItemTypeDetails'
            });
        }


        function getAllByPlaceAndRentCategoryAndTypeAndUserDateRange(placeId, rentCategoryId, itemTypeId, userId, fromDateUtc, toDateUtc) {
            return repositorySvc.customGet('getAllByPlaceAndRentCategoryAndTypeAndUserDateRange', Rent, {
                fromDateUtc: moment(fromDateUtc).startOf('day').utc().format(),
                toDateUtc: moment(toDateUtc).endOf('day').utc().format(),
                placeId: placeId,
                rentCategoryId: rentCategoryId,
                itemTypeId: itemTypeId,
                userId: userId,
                expanded: 'PersonalInformation,RentItemDetails,RentCategoryDetails,ItemTypeDetails'
            });
        }

        function getAllByPlaceAndRentCategoryAndTypeAndDateRange(placeId, rentCategoryId, itemTypeId, fromDateUtc, toDateUtc) {
            return repositorySvc.customGet('getAllByPlaceAndRentCategoryAndTypeAndDateRange', Rent, {
                fromDateUtc: moment(fromDateUtc).startOf('day').utc().format(),
                toDateUtc: moment(toDateUtc).endOf('day').utc().format(),
                placeId: placeId,
                rentCategoryId: rentCategoryId,
                itemTypeId: itemTypeId,
                expanded: 'PersonalInformation,RentItemDetails,RentCategoryDetails,ItemTypeDetails'
            });
        }

        return {
            createNew: createNew,
            getById: getById,
            getAll: getAll,
            getAllByPlaceAndDateRange: getAllByPlaceAndDateRange,
            getAllByPlaceAndItemAndDateRange: getAllByPlaceAndItemAndDateRange,
            getAllByPlaceAndRentCategoryAndTypeAndUserDateRange: getAllByPlaceAndRentCategoryAndTypeAndUserDateRange,
            getAllByPlaceAndRentCategoryAndTypeAndDateRange: getAllByPlaceAndRentCategoryAndTypeAndDateRange,
            insert: insert,
            remove: remove,
            update: update,
            modelToDTO: modelToDTO
        }
    }
]);